module.exports = __webpack_public_path__ + "img/1353.971cb101.gif";